import { ImageType } from "./common";

export enum ChallengeStatus {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  STARTED = "STARTED",
  DETERMINING_WINNERS = "DETERMINING_WINNERS",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
  COMING_SOON = "COMING_SOON",
  FAILED = "FAILED",
}

export type ChallengeResponse = {
  id: string;
  images: ImageType[];
  status: ChallengeStatus;
  deadline: string;
  name: string;
  description: string;
  is_new: boolean;
  conditions: string;
  youtube_link: string;
  target_amount: string;
  gained_amount: string;
  participant_fee: string;
  opportunity_fee: string;
  participants_count: number;
  is_participating: boolean;
  my_opportunities: number;
};

export type ChallengeSuperWinner = {
  id: string;
  full_name: string;
  username: string;
  avatar: ImageType;
  is_premium: boolean;
  opportunities: number;
};

export type ChallengeDetail = {
  id: string;
  images: ImageType[];
  status: ChallengeStatus;
  name: string;
  is_new: boolean;
  deadline: string;
  description: string;
  conditions: string;
  youtube_link: string;
  target_amount: string;
  gained_amount: string;
  participant_fee: string;
  opportunity_fee: string;
  participants_count: number;
  is_participating: boolean;
  is_premium: boolean;
  my_opportunities: number;
  my_position: number;
  super_winner: ChallengeSuperWinner | null;
  super_award?: string;
};

export type StaticPageDetail = {
  id: string;
  slug: string;
  medias: ImageType[];
  content: string;
  title?: string;
};

export type ChallengeMember = {
  user_id: string;
  full_name: string;
  username: string;
  position: number;
  gift_award?: string;
  avatar: ImageType | null;
  is_premium: boolean;
  opportunities: number;
  created_at: string;
};
